import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import mobileConfigActions from '../../../../../actions/mobileConfig.actions';
import helper from '../../../../../utils/helper';
import Backend from '../../../../Layouts/Backend';
import { Loading } from '../../../../UI/Common';
import MobileConfigurationForm from '../CreateEditForm';

function NewMobileConfiguration(props) {
  const roleNames =
    JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  // const form = {
  //   name: '',
  //   alertsOnly: false,
  //   scrollTopMin: 0,
  //   dimDisplayMin: 0,
  //   keepAwake: true,
  //   accessibleTypes: false,
  //   desiredUserId: isAdmin
  //     ? undefined
  //     : JSON.parse(localStorage.getItem('userProfile')).id || null,
  //   userName: isAdmin
  //     ? undefined
  //     : JSON.parse(localStorage.getItem('userProfile')).email || null,
  // };
  const { deptId, id } = helper.parseQueryString(props.location.search);
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState('');
  const [form, setForm] = React.useState(null);
  React.useEffect(() => {
    props.configureActions.getUsers();
  }, []);
  React.useEffect(() => {
    props.mobileConfigActions
      .getSpecificMobileConfig(id)
      .then((resp) =>
        setForm({
          ...resp,
          accessibleTypes: true,
          desiredUserId: isAdmin
            ? undefined
            : JSON.parse(localStorage.getItem('userProfile')).id || null,
          userName: isAdmin
            ? undefined
            : JSON.parse(localStorage.getItem('userProfile')).email || null,
        }),
      )
      .catch((err) => console.log(err));
  }, [id]);
  const onCreate = async (values) => {
    setError('');
    setSubmitting(true);
    await props.mobileConfigActions
      .copyMobileConfig(id, {
        ...values,
        desiredName: values.name,
        departmentId: deptId,
        accessibleTypes: values.accessibleTypes ? 0 : 1,
      })
      .then(() => props.history.goBack())
      .catch((err) => {
        setSubmitting(false);
        setError(err);
      });
  };
  if (form === null) {
    return (
      <Backend>
        <div className="content-inner">
          <Loading />
        </div>
      </Backend>
    );
  }
  return (
    <MobileConfigurationForm
      isCopy
      users={props.configure.users}
      initialValues={form}
      onSubmit={onCreate}
      submitting={isSubmitting}
      errors={error}
    />
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    mobileConfigActions: bindActionCreators(
      Object.assign({}, mobileConfigActions),
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewMobileConfiguration);
